module.exports = __webpack_public_path__ + "static/DarksideDetective5-bea23eedaddd35154db7dd107fd4f576.png";